/**
 * ViewButton Handler для форм ресурсів
 * 
 * Додає кнопку "Переглянути" що переключає режим з edit на view
 */

import React from 'react'
import { GrView } from 'react-icons/gr'
import type { IFormButtonHandlerParams } from '../../types'

/**
 * Додає кнопку "Переглянути"
 * Відображається в режимі редагування, коли є ID запису
 * 
 * @param params - параметри з buttons та crudContext
 */
export const ViewButton = ({ buttons, crudContext }: IFormButtonHandlerParams) => {
    buttons['view'] = {
        sort: 1000,
        icon: React.createElement(GrView),
        depFn: () => {
            return crudContext && 
                crudContext.actions &&
                typeof crudContext.actions.view === 'function' &&
                crudContext.formContext?.isEditable && 
                crudContext.formContext?.values?.['@id']?.length > 0
        },
        size: 'middle',
        label: 'Переглянути',
        onClick: () => {
            if (crudContext?.actions?.view && crudContext?.formContext?.values) {
                crudContext.actions.view(crudContext.formContext.values)
            }
        },
    }
}
